module.exports = __webpack_public_path__ + "img/82200.8e59b2da.jpg";